import Vue from 'vue'
import VueRouter from 'vue-router'

import goTo from 'vuetify/lib/services/goto'

// Pages.
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        onlyNotLogged: true
      }
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      onlyLogged: true
    }
  }
]

const scrollBehavior = (to)=>{
    if (to.hash)
        return goTo(to.hash)
    
    return goTo(0)
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior
})

/**
 * 🔒 Auth Gateway.
 */
router.beforeEach((to, from, next) => {

  const loggedIn = localStorage.getItem('user')

  // auth check
  if (to.matched.some(record => record.meta.onlyLogged) && !loggedIn) {
    next('/login')
    return
  }

  if (to.matched.some(record => record.meta.onlyNotLogged) && loggedIn) {
    next('/')
    return
  }

  next()

})


/**
router.beforeEach((to, from, next) => {
  
  const //authUser = store.getters["auth/authUser"],
        authUser = localStorage.getItem('user'),
        reqAuth = to.matched.some((record) => record.meta.onlyLogged),
        loginQuery = { path: "/login", query: { redirect: to.fullPath } }

        console.log(reqAuth, authUser)

  if (reqAuth && !authUser) {
    
    store.dispatch("auth/getAuthUser").then(() => {
      if (!store.getters["auth/authUser"]) next(loginQuery);
      else next();
    })

  } else {
    
    next()
  }

});
*/

export default router